import { elevation as elevationMap } from "../elevation";
export const elevation = (name) => {
    const value = elevationMap[name];
    if (value === undefined) {
        throw new TypeError(`Elevation "${name}" is not defined. Must be one of: [${Object.keys(elevationMap).join(", ")}]`);
    }
    return value;
};
